module.exports = __webpack_public_path__ + "img/report-is-ready-bg.svg";